import { useEffect, useState } from "react";
import { LoadingButton } from "@mui/lab";
import { SelectFromItems } from "../utils/forms/select";
import { updateChatState, generateChatProposal } from "../../utils/fgtschat/state";
import { getServerStates, statesForScript, ServerStates, ScriptKey } from "../../utils/fgtschat/serverstates";
import { openGlobalSnack } from "../utils/snack";

const SCRIPT_ITEMS = [
  { value: 'script1', label: 'FGTS (Script 1)' },
  { value: 'script2', label: 'CLT (Script 2)' },
];

/** 'script_1'|'script_2'|'fgts'|'clt' -> 'script1'|'script2'. */
function toScriptKey(v?: string): ScriptKey {
  const s = String(v || '').toLowerCase();
  if (s === 'script_2' || s === 'script2' || s === 'clt') return 'script2';
  return 'script1';
}

export function FgtsChatControls({ currentState, currentScript, chatId }: {
  currentState: string | undefined;
  currentScript?: string;
  chatId?: number;
}) {
  const [serverStates, setServerStates] = useState<ServerStates | undefined>(undefined);
  const [script, setScript] = useState<ScriptKey>(toScriptKey(currentScript));
  const [newState, setNewState] = useState<string>('');
  const [updating, setUpdating] = useState(false);
  const [generating, setGenerating] = useState(false);

  useEffect(() => {
    getServerStates().then(setServerStates);
  }, []);

  // Acompanha o script do chat selecionado quando ele muda.
  useEffect(() => {
    setScript(toScriptKey(currentScript));
    setNewState('');
  }, [currentScript, chatId]);

  const stateItems = serverStates ? statesForScript(serverStates, script) : [];

  return (
    <div style={{ margin: 'auto', width: '90%', maxWidth: '300px', marginTop: '5px', marginBottom: '10px', display: 'block', textAlign: 'center' }}>
      <div style={{ marginBottom: '8px' }}>
        <SelectFromItems
          disabled={!chatId || updating}
          defaultValue={script}
          items={SCRIPT_ITEMS}
          label="Script"
          onChangeItem={(v: any) => {
            if (v !== 'script1' && v !== 'script2') return;
            setScript(v);
            setNewState('');
          }}
        />
      </div>
      <SelectFromItems
        disabled={!chatId || updating}
        defaultValue={newState}
        items={stateItems}
        label="Atualizar Estado Chat"
        onChangeItem={(v: any) => setNewState(v)}
      />
      <div style={{ marginTop: '6px' }}>
        <LoadingButton
          fullWidth
          loading={updating}
          disabled={!chatId || !newState || newState === currentState}
          variant="contained"
          onClick={apply}
        >
          Atualizar Estado
        </LoadingButton>
      </div>
      <div style={{ marginTop: '8px' }}>
        <LoadingButton
          fullWidth
          color="secondary"
          loading={generating}
          disabled={!chatId || updating}
          variant="contained"
          onClick={generateProposal}
        >
          Gerar Proposta ({script === 'script2' ? 'CLT' : 'FGTS'})
        </LoadingButton>
      </div>
    </div>
  );

  function generateProposal() {
    if (!chatId) return;
    if (!window.confirm('Gerar a proposta para este chat? O cliente será notificado por WhatsApp.')) return;
    setGenerating(true);
    generateChatProposal(chatId, script).then(() => {
      setGenerating(false);
      openGlobalSnack('Proposta sendo gerada. Acompanhe o estado do chat.', 'success');
    }).catch(() => {
      setGenerating(false);
      openGlobalSnack('Não foi possível gerar a proposta.', 'error');
    });
  }

  function apply() {
    if (!chatId || !newState) return;
    setUpdating(true);
    updateChatState(chatId, newState, script).then(() => {
      setUpdating(false);
      openGlobalSnack('Estado atualizado.', 'success');
    }).catch(() => {
      setUpdating(false);
      openGlobalSnack('Não foi possível atualizar o estado.', 'error');
    });
  }
}
